import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { MenuItem, Typography } from '@mui/material';
import { InputWrapper } from './InputWrapper';
import { IconWrapper } from 'components/Icon';
import { useState } from 'react';

export function Select({
  name,
  native = false,
  maxHeight = 220,
  helperText = '',
  // children,
  PaperPropsSx = {},
  disabled = false,
  fullWidth = false,
  required = false,
  labelSx = {},
  wrapperSx = {},
  label = '',
  options = [],
  placeholder = '',
  ...other
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { control, setValue, getValues } = useFormContext();
  const isDisabled = disabled || options.length === 1;

  const handleToggle = () => setMenuOpen((open) => !open);

  useEffect(() => {
    if (options.length === 1) {
      const singleOptionValue = options[0].value;
      const currentValue = getValues(name);

      if (currentValue !== singleOptionValue) {
        setValue(name, singleOptionValue, { shouldValidate: true });
      }
    }
  }, [options, name, setValue, getValues]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <InputWrapper
            disabled={isDisabled}
            error={!!error}
            label={label}
            fullWidth={fullWidth}
            required={required}
            labelSx={labelSx}
            wrapperSx={wrapperSx}
          >
            <TextField
              {...field}
              select
              fullWidth
              disabled={isDisabled}
              InputProps={{
                endAdornment: null,
              }}
              SelectProps={{
                native,
                onOpen: handleToggle,
                onClose: handleToggle,
                IconComponent: () => (
                  <IconWrapper
                    icon={menuOpen ? 'chevronUp' : 'chevronDown'}
                    sx={{ pr: 1.5, svg: { height: 20, width: 20 } }}
                  />
                ),
                MenuProps: {
                  PaperProps: {
                    sx: {
                      ...(!native && {
                        maxHeight: typeof maxHeight === 'number' ? maxHeight : 'unset',
                      }),
                      ...PaperPropsSx,
                    },
                  },
                },
                displayEmpty: true,
                renderValue: (selectedValue) => {
                  if (!selectedValue) {
                    return (
                      <Typography color="text.secondary" sx={{ opacity: 1, fontWeight: 500, fontSize: '0.875rem' }}>
                        {placeholder}
                      </Typography>
                    );
                  }

                  const selectedOption = options.find(
                    (option) => option.value === selectedValue
                  );

                  return selectedOption ? selectedOption.label : '';
                },
              }}
              error={!!error}
              helperText={error ? error?.message : helperText}
              {...other}
            >
              {options.map(({ label, value, disabled: optionDisabled }, index) => (
                <MenuItem value={value} key={value + index} disabled={value === '' || !!optionDisabled} sx={{ fontWeight: 500}}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
          </InputWrapper>
        );
      }}
    />
  );
}
